import { getStore } from "owa-app-auth-ui-store";
import { isMsalFlowEnabled } from "owa-msaljs/lib/isMsalFlowEnabled";

export function showAuthInfoBar(): boolean {
    return isMsalFlowEnabled() && getStore().isSignInRequired;
}
